import { IUserIdentityConflictInfo } from '~src/authentication/models/IUserIdentityConflictInfo';
import { GetUserIdentityConflictsRequest } from '~src/authentication/requests/GetUserIdentityConflictsRequest';
import { WebClientListResourceFetcher } from '~src/commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { IListFetcher } from '~src/ts/fetchers/IListFetcher';
import { ServerApiMapper } from '~src/ts/helpers/ServerModelHelper';
import { IListResource } from '~src/ts/resources/Resource';
import { ResourceQuery } from '~src/ts/resources/ResourceQuery';


class UserIdentityConflictsResource implements IListResource<IUserIdentityConflictInfo> {

  private listFetcher: IListFetcher<IUserIdentityConflictInfo> = new WebClientListResourceFetcher(GetUserIdentityConflictsRequest, ServerApiMapper.userIdentityConflicts);

  public all(): ResourceQuery<IUserIdentityConflictInfo> {
    return new ResourceQuery(this.listFetcher);
  }
}

export const UserIdentityConflicts = new UserIdentityConflictsResource();
